import config from "@Config/index";

const getSubsectionIndex = ({
  resultCount,
  index,
  areFiltersApplied,
  areFiltersAppliedV2,
  isFiltersSubsectionEnabled = false,
  isMobile = false,
  isGridView = false,
  isTabletView = false,
}: {
  resultCount: number;
  index: number;
  areFiltersApplied: boolean;
  areFiltersAppliedV2: boolean;
  isFiltersSubsectionEnabled?: boolean;
  isMobile?: boolean;
  isGridView?: boolean;
  isTabletView?: boolean;
}) => {
  // With feature flag
  if (isFiltersSubsectionEnabled) {
    const shouldShowFilters =
      !areFiltersApplied && resultCount >= 20 && (isGridView ? index === 6 : index === 5);
    const shouldShowFiltersV2 =
      !areFiltersAppliedV2 && resultCount >= 20 && (isGridView ? index === 11 : index + 1 === 10);
    const shouldShowTrustPilot = index === 17;
    const shouldShowBookEarlySection = index === 23;
    const shouldShowRecentlyViewdSection = false; // reverting code for Recent rails on search page
    let shouldShowGetHelpBanner = isMobile
      ? index !== 0 && (index % 24 === 0 || index % 30 === 0)
      : index !== 0 && index % 30 === 0;

    if (resultCount >= 10 && resultCount < 14) {
      // In case when properties count is lesser than 14 then sub-sections to show up after every 5th card
      shouldShowGetHelpBanner = index === 9;
    } else if (resultCount < 10) {
      if (isGridView && resultCount > 3) {
        shouldShowGetHelpBanner = index !== 0 && index % (isTabletView ? 4 : 3) === 0;
      } else {
        // In case when properties count is lesser than 10, single sub-section of Get help to be show up after last property card
        shouldShowGetHelpBanner = index === resultCount - 1;
      }
    }

    return {
      shouldShowTrustPilot,
      shouldShowGetHelpBanner,
      shouldShowBookEarlySection,
      shouldShowFilters,
      shouldShowFiltersV2,
      shouldShowRecentlyViewdSection,
    };
  }

  // Without feature flag
  const shouldShowTrustPilot = index === 11; // As requested by the product team the Trustpilot banner should show up after 7th search list element
  const shouldShowFilters = !areFiltersApplied && resultCount >= 20 && index === 5;

  const shouldShowFiltersV2 =
    !config.IS_CHINA_APP && !areFiltersApplied && resultCount >= 20 && index + 1 === 10;
  const shouldShowRecentlyViewdSection = false; // reverting code for Recent rails on search page

  let shouldShowGetHelpBanner = index !== 0 && index % 18 === 0; // As requested by the product team the get help banner should show up after 18th search list element
  if (resultCount >= 10 && resultCount < 14) {
    // In case when properties count is lesser than 14 then sub-sections to show up after every 5th card
    shouldShowGetHelpBanner = index === 9;
  } else if (resultCount < 10) {
    // In case when properties count is lesser than 10, single sub-section of Get help to be show up after last property card
    shouldShowGetHelpBanner = index === resultCount - 1;
  }
  const shouldShowBookEarlySection = false;

  return {
    shouldShowTrustPilot,
    shouldShowGetHelpBanner,
    shouldShowBookEarlySection,
    shouldShowFilters,
    shouldShowFiltersV2,
    shouldShowRecentlyViewdSection,
  };
};
export const metaTypesHas = (arr: "", value: string) => {
  const metaTypeTokens = String(arr || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  let isPresent = false;
  metaTypeTokens.forEach((token) => {
    if (token === value) {
      isPresent = true;
    }
  });
  return isPresent;
};

export default getSubsectionIndex;
